var map = {
  "./uk.json": [
    "129965",
    [
      63449
    ]
  ],
  "./fi.json": [
    "184024",
    [
      12926
    ]
  ],
  "./el.json": [
    "431740",
    [
      40878
    ]
  ],
  "./fr-CA.json": [
    "185132",
    [
      45422
    ]
  ],
  "./ja.json": [
    "225196",
    [
      80642
    ]
  ],
  "./ar.json": [
    "642526",
    [
      99868
    ]
  ],
  "./nn.json": [
    "949241",
    [
      94481
    ]
  ],
  "./cy.json": [
    "875749",
    [
      14225
    ]
  ],
  "./en-AU-x-unimelb.json": [
    "472541",
    [
      82733
    ]
  ],
  "./fr.json": [
    "831821",
    [
      52293
    ]
  ],
  "./ga.json": [
    "19161",
    [
      11333
    ]
  ],
  "./en-GB-x-ukhe.json": [
    "99575",
    [
      73815
    ]
  ],
  "./da-x-k12.json": [
    "392004",
    [
      41582
    ]
  ],
  "./nb.json": [
    "286309",
    [
      73917
    ]
  ],
  "./sl.json": [
    "690678",
    [
      35740
    ]
  ],
  "./en-CA.json": [
    "186381",
    [
      94689
    ]
  ],
  "./en.json": [
    "781390",
    [
      64628
    ]
  ],
  "./pl.json": [
    "948245",
    [
      4717
    ]
  ],
  "./es-ES.json": [
    "347160",
    [
      92318
    ]
  ],
  "./nb-x-k12.json": [
    "388547",
    [
      54024
    ]
  ],
  "./hu.json": [
    "24154",
    [
      47348
    ]
  ],
  "./pt-BR.json": [
    "753720",
    [
      69998
    ]
  ],
  "./sv-x-k12.json": [
    "318670",
    [
      57096
    ]
  ],
  "./sv.json": [
    "665468",
    [
      95806
    ]
  ],
  "./ca.json": [
    "215325",
    [
      11225
    ]
  ],
  "./de.json": [
    "949462",
    [
      4624
    ]
  ],
  "./hy.json": [
    "41854",
    [
      51064
    ]
  ],
  "./th.json": [
    "804765",
    [
      91829
    ]
  ],
  "./vi.json": [
    "928712",
    [
      85806
    ]
  ],
  "./ht.json": [
    "13861",
    [
      40893
    ]
  ],
  "./tr.json": [
    "516971",
    [
      87975
    ]
  ],
  "./zh-Hant.json": [
    "830795",
    [
      43575
    ]
  ],
  "./en-GB.json": [
    "371388",
    [
      28126
    ]
  ],
  "./da.json": [
    "687130",
    [
      31732
    ]
  ],
  "./en-AU.json": [
    "74179",
    [
      89459
    ]
  ],
  "./en-GB-x-lbs.json": [
    "994783",
    [
      20719
    ]
  ],
  "./he.json": [
    "63498",
    [
      92900
    ]
  ],
  "./id.json": [
    "272392",
    [
      31802
    ]
  ],
  "./es.json": [
    "983941",
    [
      94113
    ]
  ],
  "./ko.json": [
    "672991",
    [
      60439
    ]
  ],
  "./zh-Hans.json": [
    "462006",
    [
      77760
    ]
  ],
  "./ms.json": [
    "861741",
    [
      35145
    ]
  ],
  "./is.json": [
    "727649",
    [
      55021
    ]
  ],
  "./nl.json": [
    "172159",
    [
      24875
    ]
  ],
  "./fa.json": [
    "130464",
    [
      30918
    ]
  ],
  "./pt.json": [
    "174957",
    [
      7557
    ]
  ],
  "./ru.json": [
    "811816",
    [
      26414
    ]
  ],
  "./it.json": [
    "320888",
    [
      22922
    ]
  ],
  "./mi.json": [
    "987355",
    [
      83227
    ]
  ],
  "./hi.json": [
    "606702",
    [
      51528
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 588555;
module.exports = __rspack_async_context;
